var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card shadow-sm" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("static-loading-indicator-icon", {
            attrs: { loading: _vm.$store.getters.shouldLoadLocal }
          }),
          _vm._v(" "),
          !_vm.$store.getters.shouldLoadLocal
            ? _c("div", [
                _c("h3", { staticClass: "card-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("pages.subscription.start.questions.title")
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.questions !== null
                  ? _c(
                      "div",
                      _vm._l(_vm.questions, function(question, i) {
                        return _c("div", { key: i, staticClass: "mt-4" }, [
                          _c(
                            "h5",
                            {
                              staticClass: "font-weight-lighter",
                              class: { "text-danger": question.answer }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(question.text) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check-inline" }, [
                            question.answer
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "text-danger font-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "pages.subscription.start.questions.answer_yes"
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _c("p", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.subscription.start.questions.answer_no"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                          ]),
                          _vm._v(" "),
                          _c("hr")
                        ])
                      }),
                      0
                    )
                  : _c("div", [
                      _c("p", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "pages.admin.users.information.health.empty"
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ])
              ])
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }